
export const PROJECT_ID = process.env.REACT_APP_APPWRITE_PROJECT_ID;
export const DATABASE_ID = process.env.REACT_APP_APPWRITE_DATABASE_ID;
export const PROJECT_KEY  = process.env.REACT_APP_APPWRITE_API_KEY;
export const APPWRITE_END_POINT=process.env.REACT_APP_APPWRITE_ENDPOINT;
//Collections
export const COLLECTION_PET_ID = process.env.REACT_APP_APPWRITE_PET_COLLECTION_ID;
export const COLLECTION_PRODUCTS_ID = process.env.REACT_APP_APPWRITE_PRODUCTS_COLLECTION_ID;